import { Link } from 'react-router-dom';
import type { NewsItem } from '@/types/content';
import { formatDate, formatViews } from '@/utils/content';

interface NewsCardProps {
  item: NewsItem;
  compact?: boolean;
}

export default function NewsCard({ item, compact = false }: NewsCardProps) {
  return (
    <Link
      to={`/news/${item.id}`}
      className="group block bg-background-100 border border-background-200 rounded-lg overflow-hidden hover:border-primary-500/60 transition-colors cursor-pointer"
    >
      <div className={`relative w-full overflow-hidden ${compact ? 'h-40' : 'h-44 md:h-48'}`}>
        <img
          src={item.cover}
          alt={item.title}
          title={`${item.title} - ${item.categoryName}`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-3 left-3 px-2 py-0.5 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
          {item.categoryName}
        </span>
        {item.hot && (
          <span className="absolute top-3 right-3 px-2 py-0.5 rounded-md bg-accent-500 text-background-50 text-xs font-medium flex items-center gap-1">
            <i className="ri-fire-fill" />热
          </span>
        )}
      </div>
      <div className="p-4">
        <h3 className="font-heading text-base font-semibold text-foreground-950 line-clamp-2 group-hover:text-primary-400 transition-colors leading-snug">
          {item.title}
        </h3>
        <p className="text-sm text-foreground-600 mt-2 line-clamp-2 leading-relaxed">{item.summary}</p>
        <div className="flex items-center gap-3 mt-3.5 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line" />
            {formatDate(item.date)}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" />
            {formatViews(item.views)}
          </span>
        </div>
      </div>
    </Link>
  );
}